(function () {
  'use strict';
  if (window.__mfaInit) return;
  window.__mfaInit = true;

  function fmtSize(v) {
    var f = window.mfaFmtSize ? window.mfaFmtSize(v) : null;
    return f ? f.inch + ' (' + f.cm + ')' : v;
  }
  function moneyFormat() {
    var el = document.querySelector('[data-mfa-money]');
    try { return el ? JSON.parse(el.textContent) : '${{amount}}'; } catch (e) { return '${{amount}}'; }
  }
  function formatMoney(cents) {
    var n = (parseInt(cents, 10) / 100).toFixed(2).split('.');
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = moneyFormat()
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + n[1])
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + n[1]);
    return out.replace(/[.,]00(?!\d)/, '');
  }

  var variants = [];
  try { variants = JSON.parse((document.querySelector('[data-mfa-variants]') || {}).textContent || '[]'); } catch (e) {}

  function currentOptions() {
    var sel = [];
    document.querySelectorAll('.mfa-opt').forEach(function (opt) {
      var pos = parseInt(opt.getAttribute('data-mfa-option'), 10) - 1;
      var c = opt.querySelector('.mfa-radio:checked');
      if (c) sel[pos] = c.value;
    });
    return sel;
  }
  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) { if (opts[j] != null && v.o[j] !== opts[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  /* ---------- frame dropdown ---------- */
  function syncFrames() {
    var opts = currentOptions();
    document.querySelectorAll('.mfa-opt--frame').forEach(function (opt) {
      var pos = parseInt(opt.getAttribute('data-mfa-option'), 10) - 1;
      opt.querySelectorAll('.mfa-flist__item').forEach(function (li) {
        var r = li.querySelector('.mfa-radio');
        var o = opts.slice(); o[pos] = r.value;
        var v = findVariant(o);
        var p = li.querySelector('[data-mfa-fprice]');
        if (p) p.textContent = v ? formatMoney(v.p) : '';
        li.classList.toggle('is-unavailable', !v || !v.a);
      });
      var c = opt.querySelector('.mfa-radio:checked');
      if (!c) return;
      var lab = c.nextElementSibling;
      var img = opt.querySelector('[data-mfa-fsel-img]');
      if (img && lab) img.style.backgroundImage = 'url(' + lab.getAttribute('data-img') + ')';
      var nm = opt.querySelector('[data-mfa-fsel-name]'); if (nm && lab) nm.textContent = lab.getAttribute('data-name');
      var hp = opt.querySelector('[data-mfa-fsel-help]'); if (hp && lab) hp.textContent = lab.getAttribute('data-help');
      var pr = opt.querySelector('[data-mfa-fsel-price]'); var lp = lab && lab.querySelector('[data-mfa-fprice]');
      if (pr && lp) pr.textContent = lp.textContent;
      var top = opt.querySelector('[data-mfa-selected]'); if (top && lab) top.textContent = lab.getAttribute('data-name');
    });
  }

  /* ---------- size scale preview (drawn in inches) ---------- */
  function syncScale() {
    var box = document.querySelector('[data-mfa-scale]');
    if (!box) return;
    var opt = box.closest('.mfa-opt');
    var c = opt && opt.querySelector('.mfa-radio:checked');
    var f = c && window.mfaFmtSize ? window.mfaFmtSize(c.value) : null;
    if (!f) { box.style.display = 'none'; return; }
    box.style.display = '';
    var a = f.a, b = f.b, w, h, o = box.getAttribute('data-orient');
    var big = Math.max(a, b), small = Math.min(a, b);
    if (o === 'h') { w = big; h = small; } else if (o === 'v') { w = small; h = big; } else { w = b; h = a; }
    var artBottom = 42, top = artBottom + h + 8, W = Math.max(150, w + 40);
    var svg = box.querySelector('svg');
    svg.setAttribute('viewBox', (-W / 2) + ' ' + (-top) + ' ' + W + ' ' + (top + 3));
    svg.innerHTML =
      '<line x1="' + (-W / 2) + '" y1="0" x2="' + (W / 2) + '" y2="0" stroke="#dedede" stroke-width="0.8"/>' +
      '<rect x="-40" y="-33" width="80" height="20" rx="4" fill="#dcd8d1"/>' +
      '<rect x="-44" y="-19" width="88" height="15" rx="4" fill="#e6e3de"/>' +
      '<rect x="-41" y="-4" width="3" height="4" fill="#cfcac2"/><rect x="38" y="-4" width="3" height="4" fill="#cfcac2"/>' +
      '<rect x="' + (-w / 2) + '" y="' + (-(artBottom + h)) + '" width="' + w + '" height="' + h + '" fill="#efe9df" stroke="#1E3A2F" stroke-width="' + (W / 160) + '"/>';
    var lbl = box.querySelector('[data-mfa-scale-label]');
    if (lbl) lbl.textContent = f.inch;
  }

  function setLabel(opt, value) {
    var label = opt && opt.querySelector('[data-mfa-selected]');
    if (!label) return;
    if (label.hasAttribute('data-mfa-size')) label.textContent = fmtSize(value);
  }

  function syncAll() { syncFrames(); syncScale(); }
  syncAll();

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('mfa-radio')) return;
    setLabel(t.closest('.mfa-opt'), t.value);
    var d = t.closest('[data-mfa-fsel]');
    if (d) d.open = false;
    window.setTimeout(syncAll, 0);
  });

  /* ---------- size guide dialog ---------- */
  var guide = document.getElementById('mfa-guide');
  function openGuide() {
    if (!guide) return;
    if (typeof guide.showModal === 'function') guide.showModal(); else guide.setAttribute('open', '');
    document.documentElement.classList.add('mfa-lock');
  }
  function closeGuide() {
    if (!guide) return;
    if (typeof guide.close === 'function') guide.close(); else guide.removeAttribute('open');
    document.documentElement.classList.remove('mfa-lock');
  }
  if (guide) {
    guide.addEventListener('click', function (e) { if (e.target === guide) closeGuide(); });
    guide.addEventListener('close', function () { document.documentElement.classList.remove('mfa-lock'); });
  }

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-mfa-more]');
    if (more) {
      var opt = more.closest('.mfa-opt');
      if (opt) opt.classList.add('mfa-show-all');
      more.parentNode.removeChild(more);
      return;
    }
    if (e.target.closest('[data-mfa-open-guide]')) { e.preventDefault(); openGuide(); return; }
    if (e.target.closest('[data-mfa-close-guide]')) { e.preventDefault(); closeGuide(); return; }
    /* close frame dropdown when clicking outside */
    document.querySelectorAll('[data-mfa-fsel][open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });

  /* ---------- sticky add to cart ---------- */
  var bar = document.querySelector('[data-mfa-sticky]');
  var atc = document.querySelector('.ProductForm__AddToCart');
  if (bar && atc) {
    var btn = bar.querySelector('[data-mfa-sticky-btn]');
    var lbl = bar.querySelector('[data-mfa-sticky-label]');
    var priceEl = bar.querySelector('[data-mfa-sticky-price]');
    var mode = 'hidden';
    var available = !btn.disabled;

    function paint() {
      if (!available) { lbl.textContent = 'Sold out'; btn.disabled = true; return; }
      btn.disabled = false;
      lbl.textContent = mode === 'before' ? 'Choose size' : 'Add to cart';
    }
    function setMode(next) {
      if (next === mode) return;
      mode = next;
      var on = next !== 'hidden';
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.documentElement.classList.toggle('mfa-sticky-on', on);
      paint();
    }
    function check() {
      var r = atc.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < vh - 40 && r.bottom > 0) setMode('hidden');
      else if (r.top >= vh - 40) setMode('before');
      else setMode('after');
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { check(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', check);
    check();

    btn.addEventListener('click', function () {
      if (mode === 'before') {
        var first = document.querySelector('.mfa-opt') || atc;
        window.scrollTo({ top: first.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
        return;
      }
      if (!atc.disabled) atc.click();
    });

    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) { available = false; paint(); return; }
      available = !!v.available;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      paint();
      syncAll();
    });
  }

  /* ---------- homepage faq: one open at a time ---------- */
  document.querySelectorAll('.mfa-faq').forEach(function (wrap) {
    wrap.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      wrap.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });
})();
